var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009eaf;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,6.7c8.8,0,11.8-6,20.6-6,23.6,0,47.2,20.7,67.9,41.3C157.8,62.7,134.2,89.3,90,89.3S22.1,62.7,1.5,42.1C22.1,21.4,45.7.7,69.3.7c8.9,0,11.8,6,20.7,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.7,31.7H81V43c0,3.3-1.4,4.3-3,4.3s-3.4-.9-3.4-4V36c0-3.2-1.3-4.3-4.4-4.3H67.5V43.1c0,6.6,3.6,9.9,10.2,9.9s10.4-3.1,10.4-9.7V36c0-3-1.5-4.3-4.4-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.5,43.1c0,3.2-1.4,4.2-3.2,4.2s-3.2-4.6-3.2-5.1V41c0-3.2,1.5-4.1,3.2-4.1S56.5,38,56.5,41Zm-3.2-12c-6.9,0-10.4,3.3-10.4,10.7V53.4c0,3,1.6,4.2,4.4,4.2h2.8V50.3a5.6,5.6,0,0,0,4.8,2.4c5.3,0,8.9-3.7,8.9-9.4V41c0-6.6-3.8-9.9-10.5-9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.3,41c0-6.6-3.6-9.9-10.2-9.9s-10.5,3.3-10.5,10.7v6.4c0,3,1.6,4.2,4.4,4.2h2.8V41.1c0-3.3,1.3-4.2,3-4.2a2.9,2.9,0,0,1,3.2,2.5c.4,2,1.7,2.7,4.3,2.7h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.3,31.7h-2.7V43c0,3.3-1.4,4.3-3,4.3s-3.4-.9-3.4-4V36c0-3.2-1.3-4.3-4.4-4.3H92.1V43.1c0,6.6,3.6,9.9,10.2,9.9s10.4-3.1,10.4-9.7V36c0-3-1.5-4.3-4.4-4.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuur);
export default __webpack_public_path__ + "static/media/puur.2e632fcdf6224d5252b9e7568bdb2415.svg";
export { ForwardRef as ReactComponent };